// Presentation priority only. This is not a simulated gain or an allocation score.
export function lootSlotPriority(slot, name='') {
  if (['Main hand','Off hand','One-Hand','Two-Hand','Main Hand','Off Hand','Held In Off-hand','Ranged','Ranged Right','Shield'].includes(slot)) return 0;
  if (slot === 'Trinket') return 1;
  if (['Chest','Legs'].includes(slot)) return 2;
  if (slot === 'Token / special' && /of the Cursed (Conqueror|Protector|Vanquisher)/.test(name)) return /^(Chest|Leggings) /.test(name) ? 2 : 3;
  if (['Head','Shoulder','Hands'].includes(slot)) return 3;
  return 4;
}
export function isMajorLootSlot(slot, name='') { return lootSlotPriority(slot, name) < 4; }

// Decorative vector medals render consistently in HTML and Discord's table image.
export function lootOrderMedal(position) {
  const colours={1:['#f2cc60','#9b711a'],2:['#cfd8e3','#718296'],3:['#e1ab83','#965c36']}[position];
  if(!colours)return '';
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24" width="16" height="20" aria-hidden="true" focusable="false"><path d="M3 1h5l4 9-5 2z" fill="#6a9ce5"/><path d="M12 1h5l-4 11-5-2z" fill="#d86e79"/><circle cx="10" cy="15" r="8" fill="'+colours[0]+'" stroke="'+colours[1]+'"/><circle cx="10" cy="15" r="5.5" fill="none" stroke="'+colours[1]+'" stroke-width=".8"/><path d="m10 11 1.2 2.5 2.8.4-2 2 .5 2.8-2.5-1.3-2.5 1.3.5-2.8-2-2 2.8-.4z" fill="'+colours[1]+'"/></svg>';
}

export function formatLootOrder(position,tied=false) {
  if(!Number.isInteger(position)||position<1)return 'Needs review';
  const words=['','first','second','third','fourth','fifth'];
  const ordinal=n=>n+(n%100>=11&&n%100<=13?'th':({1:'st',2:'nd',3:'rd'}[n%10]??'th'));
  if(tied)return 'Shared '+(words[position]??ordinal(position));
  return position===1?'First up':position===2?'Next up':position<=5?words[position][0].toUpperCase()+words[position].slice(1)+' in line':ordinal(position)+' in line';
}

export function explainLootOrder(position,contenders=[]) {
  if(!Number.isInteger(position)||position<1)return 'Not ranked yet. The review below must be resolved before this player can enter the order.';
  const ahead=contenders.filter(c=>c.position<position).length,shared=contenders.filter(c=>c.position===position).length-1;
  if(contenders.length===1)return 'Only currently ranked player. This does not establish that nobody else wants the item.';
  return (ahead?`${ahead} player${ahead===1?'':'s'} ahead.`:'Nobody ranked ahead.')+(shared>0?` Equal priority with ${shared} other player${shared===1?'':'s'}; no winner chosen within this tie.`:'')+' Order is provisional, not an approved award.';
}

export function formatLootGap(delta, comparison) {
  const signed=n=>(n>0?'+':'')+n;
  if(delta!==null && delta!==undefined)return signed(delta);
  if(!comparison?.against?.length)return 'Unknown';
  const gaps=comparison.against.map(g=>comparison.targetLevel-g.level);
  const low=Math.min(...gaps),high=Math.max(...gaps);
  return low===high?signed(low):signed(low)+' to '+signed(high);
}

// Use the lower end of a multi-piece comparison for conservative filtering/sorting.
export function lootGapValue(delta, comparison) {
  if(delta!==null && delta!==undefined)return delta;
  if(!comparison?.against?.length)return null;
  return Math.min(...comparison.against.map(g=>comparison.targetLevel-g.level));
}
